import { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from '../context/UserContext';

export { API_BASE } from './apiClient';

/**
 * Redirects unauthenticated users to login with return path.
 * Returns authReady so pages do not render protected UI before the check finishes.
 */
export function useRequireLogin(message = 'Please log in to continue.') {
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [authReady, setAuthReady] = useState(() => {
        if (user) return true;
        return !localStorage.getItem('user');
    });

    useEffect(() => {
        let cancelled = false;

        const finish = () => {
            if (!cancelled) setAuthReady(true);
        };

        const storedUser = localStorage.getItem('user');
        if (!user && storedUser) {
            try {
                const parsed = JSON.parse(storedUser);
                setUser(parsed);
                finish();
                return;
            } catch (error) {
                console.error('Invalid stored user session:', error);
                localStorage.removeItem('user');
            }
        }

        if (!user && !localStorage.getItem('user')) {
            navigate('/login', {
                replace: true,
                state: {
                    redirectTo: location.pathname + location.search,
                    message,
                },
            });
        }

        finish();
        return () => {
            cancelled = true;
        };
    }, [user, navigate, location, setUser, message]);

    return { authReady, isAuthenticated: !!user };
}
